import { ConnectIDPhoneFrame } from "./ConnectIDPhoneFrame";

export function ConnectIDFlow() {
  return (
    <ConnectIDPhoneFrame
      className="w-[260px] max-w-full sm:w-[280px]"
      data-testid="connectid-flow"
    />
  );
}